<app-scan-qrcode class="full-width-height" [pageMode]="true" [type]="'checkin'" [reset]="reset" (back)="goBack()"></app-scan-qrcode>
